// extracted by mini-css-extract-plugin
module.exports = {"videoCard":"videoCard_videoCard__9XjHu","collection":"videoCard_collection__83edA","featured":"videoCard_featured___qWQA"};